/**
 * De segmentknop van stijl A (genA `.seg`), één component voor elke keuze uit een
 * paar opties: gebieden, sturingslagen, Gemeente of Wijk, Alle takken of DAEB,
 * Ruim of Compact (ronde 5). Een grijze baan met de gekozen optie als witte pil.
 *
 * Knoppen met `aria-pressed` in een groep met een naam, zodat de keuze voor
 * toetsenbord en schermlezer hetzelfde is als voor de muis. Is een optie een
 * link naar een ander scherm (sturingslaag, Vastgoed-niveau), gebruik dan de
 * klassen `atl-seg` en `atl-seg__item` op de links, met `aria-current="page"`.
 *
 * Voor de onderhoudshorizon niet deze, maar `HorizonSwitch`: dat label is overal hetzelfde.
 */
import { cx } from "@/lib/cx";

import "./Segmented.css";

export type SegmentedOption<T extends string | number> = { value: T; label: string; title?: string };

export function Segmented<T extends string | number>({ label, options, value, onChange, className, size }: {
  /** Naam van de groep voor de schermlezer. */
  label: string;
  options: SegmentedOption<T>[];
  value: T | null;
  onChange: (next: T) => void;
  className?: string;
  /** `small`: lager, voor in een kaart of een paneel (genA `.seg` met `padding:2px`). */
  size?: "small";
}) {
  return (
    <div className={cx("atl-seg", size === "small" && "atl-seg--small", className)} role="group" aria-label={label}>
      {options.map((optie) => (
        <button
          key={String(optie.value)}
          type="button"
          className="atl-seg__item"
          aria-pressed={value === optie.value}
          title={optie.title}
          onClick={() => onChange(optie.value)}
        >
          {optie.label}
        </button>
      ))}
    </div>
  );
}
